// @flow
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Controller, Scene } from "@thesatoshicompany/react-scrollmagic";
import { Tween, Timeline } from "react-gsap";
import { RoundedButton } from "./shared/StyledComponents";
import { ChevronLeft } from "@material-ui/icons";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Link } from "react-router-dom";

function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
}

const ImpactScrollerStyled = styled.div`
  .section {
    background: linear-gradient(160deg, #f47c66 0%, #e51906 100%);
  }

  .sticky {
    height: 100vh;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 100vh;
    display: flex;

    .crossmark {
      position: absolute;
      width: 50px;
      height: 50px;
      border-radius: 25px;
      -webkit-backdrop-filter: blur(10px);
      backdrop-filter: blur(10px);
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
      border: solid 1px #ffffff;
      background-color: rgba(255, 255, 255, 0.8);
      color: #4371cc;
      span {
        font-size: 25px;
        line-height: 20px;
        vertical-align: middle;
      }
    }
  }

  .stickyHeader {
    z-index: 99;
    top: 50px !important;
    position: sticky;
    height: 0px;
    overflow: visible;
    margin-bottom: 90vh;
    margin-top: -90vh;

    .stickHeaderItems {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      margin: 0 2rem;
    }

    .backButton {
      margin-right: -2rem;
    }

    .slider {
      -webkit-appearance: none; /* Override default CSS styles */
      appearance: none;
      border-radius: 25%;
      height: 4px;
      background-color: rgba(216, 216, 216, 0.9);
      outline: none; /* Remove outline */
      -webkit-transition: 0.2s; /* 0.2 seconds transition on hover */
      transition: opacity 0.2s;
      margin: 0px auto !important;
    }
  }

  input[type="range"] {
    -webkit-appearance: none;
    margin: 10px 0;
    width: 50%;
  }
  input[type="range"]:focus {
    outline: none;
  }
  input[type="range"]::-webkit-slider-runnable-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    animate: 0.2s;
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
    background: rgba(216, 216, 216, 0.9);
    border-radius: 25px;
    border: 0px solid #000101;
  }
  input[type="range"]::-webkit-slider-thumb {
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
    border: 0px solid #000000;
    height: 55px;
    width: 55px;
    border-radius: 7px;
    background: url(data:image/png;base64,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)
      no-repeat;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -25px;
  }
  input[type="range"]:focus::-webkit-slider-runnable-track {
    background: rgba(216, 216, 216, 0.9);
  }
  input[type="range"]::-moz-range-track {
    width: 50%;
    height: 4px;
    cursor: pointer;
    animate: 0.2s;
    /* box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d; */
    background: rgba(216, 216, 216, 0.9);
    border-radius: 25px;
    border: 0px solid #000101;
    appearance: none;
  }
  input[type="range"]::-moz-range-thumb {
    /* box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d; */
    border: 0px solid #000000;
    height: 55px;
    width: 55px;
    border-radius: 7px;
    background: url(data:image/png;base64,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)
      no-repeat;
    cursor: pointer;
    margin-top: -25px;
  }
  input[type="range"]::-ms-track {
    width: 50%;
    height: 12.8px;
    cursor: pointer;
    animate: 0.2s;
    background: transparent;
    border-color: transparent;
    border-width: 39px 0;
    color: transparent;
  }
  input[type="range"]::-ms-fill-lower {
    background: rgba(216, 216, 216, 0.9);
    border: 0px solid #000101;
    border-radius: 50px;
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
  }
  input[type="range"]::-ms-fill-upper {
    background: rgba(216, 216, 216, 0.9);
    border: 0px solid #000101;
    border-radius: 50px;
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
  }
  input[type="range"]::-ms-thumb {
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
    border: 0px solid #000000;
    height: 20px;
    width: 39px;
    border-radius: 7px;
    background: #65001c;
    cursor: pointer;
  }
  input[type="range"]:focus::-ms-fill-lower {
    background: rgba(216, 216, 216, 0.9);
  }
  input[type="range"]:focus::-ms-fill-upper {
    background: rgba(216, 216, 216, 0.9);
  }
`;

const Popover = styled.div`
  position: absolute;
  width: auto;
  max-width: ${props => (props.isDesktop ? '40%' : 'none')};
  background-color: rgba(35, 35, 41, 0.8);
  border-radius: 4px;
  text-align: left;
  padding: 10px;
  margin: 0px 40px;
  padding: 10px 15px;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  h2 {
    font-size: 1.2rem;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: 0.2px;
    margin: 0;
    color: white;
    margin-bottom: 5px;
  }
  span {
    color: white;
    font-size: 18px;
    font-weight: lighter;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.31;
    letter-spacing: -0.1px;
  }
`

const HeaderContainer = styled.div`
  .header {
    width: 100%;
    text-align: center;
    padding-top: 15vh;
    background-image: ${props => props.background};
    z-index: 1;
    color: ${props => props.textColor};
    height: 50% !important;

    .header-heading {
      font-size: 24px;
      font-weight: bold;
      letter-spacing: -0.15px;
      color: ${props => props.textColor};
    }
    .header-body {
      font-size: 18px;
      margin-top: 10px;
      font-weight: 300;
      line-height: 1.41;
      letter-spacing: -0.1px;
      color: ${props => props.textColor};
      padding: 0px 15vw;
    }
  }
`;

let isDesktopCache = false;
let locationCache = '';
let loadingCache = true;

const ImpactScroller = ({
  eventPageMissionSteps,
  stepperPrefixElements,
  stepperPostfixElements,
  contentLoading
}) => {
  const mediaQueryIsDesktop = useMediaQuery("(min-width:960px)")
  const isDesktop = window.innerWidth > 960 || mediaQueryIsDesktop;
  const calculateState = () => {
    return [
      ...eventPageMissionSteps.map(a => ({
        imageClass: a.backgroundImage.url,
        header: {
          heading: a.header,
          body: a.description,
          color: a.textColor.hex,
          background: a.textBackground
            ? `linear-gradient(
      to bottom,
      rgba(${a.textBackground.rgba.r}, ${a.textBackground.rgba.g}, ${a.textBackground.rgba.b}, 0.6) 27%,
      rgba(${a.textBackground.rgba.r}, ${a.textBackground.rgba.g}, ${a.textBackground.rgba.b}, 0)
    )`
            : "none"
        },
        snippets: a.eventPagePopovers.map(popover => {
          return ({
            showCrossMark: true,
            heading: popover.header,
            body: popover.description[0],
            positioning: {
              from: {
                left: (isDesktop ? popover.locationPercentFromLeft : 0) + "%",
                top: (isDesktop ? popover.locationPercentFromTop : 50) + "%"
              },
              to: {
                left: (isDesktop ? popover.locationPercentFromLeft : 0) + "%",
                top: (isDesktop ? popover.locationPercentFromTop : 50) + "%"
              }
            }
          })
        })
      }))
    ]
  }

  const [data, setState] = useState(calculateState());

  if (
    isDesktopCache !== isDesktop
  ) {
    isDesktopCache = isDesktop;
    setState(calculateState())
  }

  if(
    locationCache !== window.location.pathname ||
    (!contentLoading && loadingCache !== contentLoading)
  ){
      locationCache = window.location.pathname;
      loadingCache = contentLoading;
      setState(calculateState())
  }

  const [scroll, setScroll] = useState();

  useEffect(() => {
    return;
  });

  return (
    <>
      <ScrollToTopOnMount />
      <ImpactScrollerStyled>
        <div className={"stickyHeader"}>
          <div className={"stickHeaderItems"}>
            <input
              type="range"
              min="0"
              max={data.length}
              step=".0001"
              value={scroll || 0}
              onChange={a => {
                a.preventDefault();
              }}
              className="slider"
            />
            <Link to="/" className="back-button backButton">
              <RoundedButton className={"backButton"}>
                <ChevronLeft />
                {isDesktop ? "Back" : null}
              </RoundedButton>
            </Link>
          </div>
        </div>
        {stepperPrefixElements}
        <div className="section" />
        <Controller refreshInterval={100}>
          {data.map((slide, index) => {
            return (
              <Scene
                triggerHook="onLeave"
                duration={3500}
                pin
                key={index}
                onChange={({ progress }) => {
                  requestAnimationFrame(() => {
                    setScroll(index + progress);
                  });
                }}
              >
                {progress => {
                  return (
                    <div
                      className={`sticky ` + slide.imageClass}
                      style={{
                        backgroundImage: `url(${slide.imageClass})`,
                        display: 'flex',
                        justifyContent: 'center'
                      }}
                    >
                      {slide.header && (
                        <HeaderContainer
                          textColor={slide.header.color}
                          background={slide.header.background}
                        >
                          <div className="header">
                            <span className="header-heading">
                              {slide.header.heading}
                            </span>
                            <p className="header-body">{slide.header.body}</p>
                          </div>
                        </HeaderContainer>
                      )}
                      {slide && slide.snippets && slide.snippets.length > 0 && (
                        <Timeline
                          // This progress logic makes it so the top elements show first
                          totalProgress={progress}
                          paused
                          target={
                            <Popover isDesktop={isDesktopCache}>
                              <h2 className="heading">
                                {slide.snippets[0].heading}
                              </h2>
                              <span className="body">{slide.snippets[0].body}</span>
                            </Popover>
                          }
                        >
                          <Tween
                            from={{ opacity: 0, ...slide.snippets[0].positioning.to }}
                            to={{ opacity: 1, ...slide.snippets[0].positioning.to }}
                          />
                          <Tween
                            from={{ ...slide.snippets[0].positioning.to }}
                            to={{ opacity: 0, ...slide.snippets[0].positioning.to }}
                          />
                          {slide && slide.snippets && slide.snippets.length > 1 && (<Timeline
                            target={
                              <Popover isDesktop={isDesktopCache}>
                                <h2 className="heading">
                                  {slide.snippets[1].heading}
                                </h2>
                                <span className="body">{slide.snippets[1].body}</span>
                              </Popover>
                            }
                          >
                            <Tween
                              from={{ opacity: 0, ...slide.snippets[1].positioning.to }}
                              to={{ opacity: 1, ...slide.snippets[1].positioning.to }}
                            />
                            <Tween
                              from={{ ...slide.snippets[1].positioning.to }}
                              to={{ opacity: 0, ...slide.snippets[1].positioning.to }}
                            />
                          </Timeline>)}
                        </Timeline>
                      )}
                    </div>
                  );
                }}
              </Scene>
            );
          })}
        </Controller>
        <div className="section" />
        {stepperPostfixElements}
      </ImpactScrollerStyled>
    </>
  );
};

export default ImpactScroller;
